import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 1024 1024"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M810.667 938.667H213.333c-72.533 0-128-55.467-128-128V213.333c0-72.533 55.467-128 128-128h597.334c72.533 0 128 55.467 128 128v597.334c0 72.533-55.467 128-128 128m-597.334-768c-25.6 0-42.666 17.066-42.666 42.666v597.334c0 25.6 17.066 42.666 42.666 42.666h597.334c25.6 0 42.666-17.066 42.666-42.666V213.333c0-25.6-17.066-42.666-42.666-42.666z" }, null, -1),
    _createElementVNode("path", { d: "M512 725.333c-25.6 0-42.667-17.066-42.667-42.666V341.333c0-25.6 17.067-42.666 42.667-42.666s42.667 17.066 42.667 42.666v341.334c0 25.6-17.067 42.666-42.667 42.666" }, null, -1),
    _createElementVNode("path", { d: "M682.667 554.667H341.333c-25.6 0-42.666-17.067-42.666-42.667s17.066-42.667 42.666-42.667h341.334c25.6 0 42.666 17.067 42.666 42.667s-17.066 42.667-42.666 42.667" }, null, -1)
  ]))]))
}
export default { render: render }